export default {
    NOTES_API_ENDPOINT: `https://infinite-inlet-24916.herokuapp.com/api/notes`,
    FOLDERS_API_ENDPOINT: `https://infinite-inlet-24916.herokuapp.com/api/folders`,
  }